import { createBrowserRouter } from "react-router-dom";
import ProtectedPage from "../pages/ProtectedPage.tsx";
import NotFoundPage from "../pages/404Page.tsx";
import AuthProtectedRoute from "./AuthProtectedRoute.tsx";
import Providers from "../Providers.tsx";
import { AuthPage } from "@/pages/AuthPage.tsx";
import SettingsPage from "@/pages/SettingsPage.tsx";
import ChatListPage from "../pages/ChatListPage.tsx";
import EditProfileSettingsWrapper, { type EditProfileForm } from "../components/settings/EditProfileSettingsWrapper.tsx";
import SearchPage from "../pages/SearchPage.tsx";
import ScanPage from "../pages/ScanPage.tsx";
import NewChatPage from "../pages/NewChatPage.tsx";
import { UpdatePasswordPage } from "@/pages/UpdatePasswordPage.tsx";
import RootRedirector from "@/pages/RootRedirector.tsx";
import FriendProfilePage from "../pages/FriendProfilePage.tsx";
import ConversationPage from "../pages/ConversationPage.tsx";
import BotListPage from "../pages/BotListPage.tsx";
import BotChatPage from "../pages/BotChatPage.tsx";
import BotAdminPage from "../pages/BotAdminPage.tsx";
import OwnedContentGalleryPage from "../pages/OwnedContentGalleryPage.tsx";
import AgeGatePage from "@/pages/AgeGatePage.tsx";
import AgeVerifiedRoute from "./AgeVerifiedRoute.tsx";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Providers />,
    children: [
      {
        path: "/",
        element: <RootRedirector />,
      },
      {
        path: "/auth",
        element: <AuthPage />,
      },
      {
        path: "/auth/update-password",
        element: <UpdatePasswordPage />,
      },
      {
        path: "/",
        element: <AuthProtectedRoute />,
        children: [
          // Age gate (self-attestation MVP). This route must remain accessible even when not age-verified.
          {
            path: "/age-gate",
            element: <AgeGatePage />,
          },
          // All other authenticated routes require age verification.
          {
            path: "/",
            element: <AgeVerifiedRoute />,
            children: [
              {
                path: "/protected",
                element: <ProtectedPage />,
              },
              {
                path: "/settingspage",
                element: <SettingsPage />,
                children: [
                  {
                    path: "editprofile",
                    element: (
                      <EditProfileSettingsWrapper
                        onSave={(profile: EditProfileForm) =>
                          console.log("Profile saved:", profile)
                        }
                        onCancel={() => window.history.back()}
                        setAvatarFile={() => {}}
                      />
                    ),
                  },
                ],
              },
              {
                path: "/chatlistpage",
                element: <ChatListPage />,
              },
              {
                path: "/searchpage",
                element: <SearchPage />,
              },
              {
                path: "/scanpage",
                element: <ScanPage />,
              },
              {
                path: "/newchatpage",
                element: <NewChatPage />,
              },
              {
                path: "/friend/:friendId",
                element: <FriendProfilePage />,
              },
              {
                path: "/chat/:conversationId",
                element: <ConversationPage />,
              },
              {
                path: "/bots",
                element: <BotListPage />,
              },
              {
                path: "/bots/:botId/manage",
                element: <BotAdminPage />,
              },
              {
                path: "/bot/:botId",
                element: <BotChatPage />,
              },
              {
                path: "/my-content",
                element: <OwnedContentGalleryPage />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

export default router;
